window.addEventListener('load', () => {
  const header = document.querySelector('header');
  let prevY = window.scrollY; // 前回のスクロール位置を初期化

  window.addEventListener('scroll', () => {
    const currentY = window.scrollY; // 現在のスクロール位置を取得
    if (currentY == 0) {
      //Safariなどのバウンススクロール対策
      header.classList.add('stop'); // hiddenクラスを追加して非表示にする
      header.classList.remove('hidden');
      header.classList.remove('fixedBtn--active');
    } else if (currentY < prevY) {
      // 上にスクロールしている場合
      header.classList.remove('fixedBtn--active');
      header.classList.remove('stop');
      header.classList.add('hidden');
    } else {
      // 下にスクロールしている場
      if (currentY > 0) {
        //Safariなどのバウンススクロール対策
        header.classList.add('fixedBtn--active'); // hiddenクラスを追加して非表示にする
        header.classList.remove('stop');
        header.classList.remove('hidden');
      }
    }
    prevY = currentY; // 前回のスクロール位置を更新
  });
});
